import copy from 'icons/copy.svg';
import globe from 'icons/globe.svg';
import { Popover } from 'ui/popover/popover.module';

import { KEY_CODES } from 'consts/consts';
import { POPOVER_ROLE } from 'consts/enum';
import { addClass, copyToClipboard } from 'helpers/helpers';
import { ENGT_CHAT } from 'js/bot.model';

import { linkPreviewTemplate } from './linkPreview.template';
import { linkPreviewIframeTemplate } from './linkPreviewIframe.template';

export class LinkPreview {
	constructor(props) {
		this.initData(props);

		setTimeout(() => {
			this.initialisePopover();
		}, 0);
	}

	initData(props) {
		this.data = {};
		const { msg, message_id, is_iframe } = props;

		this.data = {
			msg,
			message_id,
		};

		this.html = is_iframe ? linkPreviewIframeTemplate(this.data) : linkPreviewTemplate(this.data);
	}

	displayCopiedPopover(node) {
		const copyPopoverParentNode = node?.parentNode?.parentNode;
		const copiedPopoverElement = copyPopoverParentNode?.querySelector('.engt-copied-popover');
		if (copiedPopoverElement?.style) {
			copiedPopoverElement.style.display = 'block';
			setTimeout(() => {
				copiedPopoverElement.style.display = 'none';
			}, 2000);
		}
	}

	createCopiedPopover() {
		const copiedPopover = document.createElement('span');
		const copiedMessage = 'Copied';
		copiedPopover.innerHTML = copiedMessage;
		addClass(copiedPopover, 'engt-copied-popover');
		return copiedPopover;
	}

	copyContent(linkPreviewObjRef, event) {
		let copyContent = event?.target?.dataset?.linkPreviewCopy;
		copyContent = copyContent.replace('mailto:', '');
		copyToClipboard(copyContent);
		linkPreviewObjRef.displayCopiedPopover(event?.target);
	}

	getCopyIcon(node) {
		const ref = this;
		const copyIcon = `<img data-link-preview-copy=${node?.href} src="${copy}" alt="copy-icon" tabindex="0" style="cursor: pointer;" width="24" height="24"></img>`;
		const copySpan = document.createElement('span');
		copySpan.innerHTML = copyIcon;
		copySpan.addEventListener('click', ref.copyContent.bind(this, ref));
		copySpan.addEventListener('keydown', function (e) {
			const keyCode = e.which ? e.which : e.keyCode;
			const isTriggeredByEnter = keyCode === KEY_CODES.ENTER;
			if (isTriggeredByEnter) {
				ref.copyContent.call(this, ref, e);
			}
		});
		return copySpan;
	}

	getChildComponent(node) {
		const copyElement = this.getCopyIcon(node);

		const globeIcon = `<img src="${globe}" alt="globe-icon" width="24" height="24"></img>`;
		const link = `<span style="display:flex;"><a class="engt-popover-preview-content" target="_blank" href="${node?.href}">${node?.href}</a></span>`;

		const contentHtml = `<span class="engt-popover-globe-icon">${globeIcon}${link}</span>`;
		const contentSpan = document.createRange().createContextualFragment(contentHtml);

		const span = document.createElement('span');
		addClass(span, 'engt-popover-preview');
		span.appendChild(contentSpan);
		span.appendChild(copyElement);
		span.appendChild(this.createCopiedPopover());

		return span;
	}

	initialisePopover() {
		const descriptionDiv = document.querySelectorAll(`[data-link-preview-id="${this.data.message_id}"]`);

		const descriptionDivArray = [...descriptionDiv];
		descriptionDivArray
			.filter((node) => node)
			.map((node) => {
				const url = node.getAttribute('href');
				const isPdfLink = url.includes('document/viewer.html');
				const isPdfPreviewEnabled = ENGT_CHAT.get('config.isPdfLinkPreviewEnabled') && isPdfLink;
				const isWebPreviewEnabled = ENGT_CHAT.get('config.isWebLinkPreviewEnabled') && !isPdfLink;

				if (isPdfPreviewEnabled || isWebPreviewEnabled) {
					node.addEventListener('click', function (event) {
						event.preventDefault();
						ENGT_CHAT.get('onMaximizeScreen')();
						ENGT_CHAT.get('showSourcePreviewScreen')(url);
					});
				} else {
					new Popover({
						parent: node,
						child: this.getChildComponent(node),
						role: POPOVER_ROLE.TOOLTIP,
					}).render();
				}
			});
	}

	render() {
		return this.html;
	}
}
